import { ComponentProps } from "react"
import { Pressable, View } from "react-native"
import { Href, Link } from "expo-router"
import MIcon from "@react-native-vector-icons/material-design-icons"
import { SafeAreaView } from "react-native-safe-area-context"

import { ar } from "@src/i18n/ar"
import { List } from "@src/components/list"
import { Text } from "@src/components/core"
import { useNumCols } from "@src/hooks"
import { Header } from "@src/components/Header"
import { sharedStyles } from "@src/utils"

const content = [
  { title: ar.inventory, icon: "warehouse", href: "/dashboard/inventory/storage/1", bgClassName: "bg-[#F59E0B]" },
  { title: ar.suppliers, icon: "truck-delivery", href: "/dashboard/supplier", bgClassName: "bg-[#78716C]" },
  { title: ar.transactions, icon: "swap-horizontal", href: "/dashboard/transactions", bgClassName: "bg-[#64748B]" },
  { title: ar.products, icon: "package-variant-closed", href: "/dashboard/products", bgClassName: "bg-[#14B8A6]" },
  { title: ar.employees, icon: "badge-account-horizontal", href: "/dashboard/employee", bgClassName: "bg-[#3B82F6]" },
  { title: ar.payments, icon: "cash-register", href: "/dashboard/payments", bgClassName: "bg-[#0EA5E9]" },
  { title: ar.balances, icon: "scale-balance", href: "/dashboard/balances", bgClassName: "bg-[#22C55E]" },
  // old shifts.
  // { title: `${ar.shifts} (OLD)`, icon: "history", href: "/dashboard/shifts", bgClassName: "bg-[#8B5CF6]" },
  { title: ar.shifts, icon: "clock-time-eight", href: "/dashboard/shifts", bgClassName: "bg-[#D946EF]" },
  { title: ar.expenses, icon: "cash-minus", href: "/dashboard/expenses", bgClassName: "bg-[#EF4444]" },
  { title: ar.customerReturns, icon: "keyboard-return", href: "/dashboard/returns", bgClassName: "bg-[#F97316]" },
  { title: ar.wallet, icon: "wallet", href: "/dashboard/cash-wallet", bgClassName: "bg-[#10B981]" },
  { title: ar.customers, icon: "account-group", href: "/dashboard/customer", bgClassName: "bg-[#EC4899]" },
  { title: ar.notifications, icon: "bell-ring", href: "/dashboard/notifications", bgClassName: "bg-[#8B5CF6]" },
  // we need another way to handle this
  // { title: ar.inventoryMovements, icon: "chart-line", href: "/dashboard/inventory/storage/1/movement", bgClassName: "bg-[#A855F7]" },
  { title: ar.orders, icon: "basket", href: "/dashboard/orders", bgClassName: "bg-[#3c88F6]" },
  { title: ar.menu, icon: "menu", href: "/dashboard/menu", bgClassName: "bg-[#F97486]" },
  { title: ar.deliveryAreas, icon: "earth", href: "/dashboard/delivery-areas", bgClassName: "bg-[#F98486]" },
  { title: ar.scaleProducts, icon: "scale-balance", href: "/dashboard/products?type=WEIGHT_PRODUCT", bgClassName: "bg-[#F98486]" },
  { title: ar.inventoryCollections, icon: "movie-cog", href: "/dashboard/inventory/collections", bgClassName: "bg-[#080]" },
  { title: ar.inventoryReport, icon: "chart-bar", href: "/dashboard/inventory/report", bgClassName: "bg-[#7C3AED]" },
  { title: ar.salesDetails, icon: "chart-timeline-variant", href: "/dashboard/sales", bgClassName: "bg-[#0EA5E9]" },
  { title: ar.more, icon: "more", href: "/dashboard/more", bgClassName: "bg-[#AA8486]" },
] satisfies { title: string; icon: ComponentProps<typeof MIcon>["name"]; href: Href; bgClassName: string }[]

export default function Dashboard() {
  const numCols = Math.max(useNumCols(190, { maxWidth: 1200 }), 2)

  return (
    <>
      <Header title={ar.home} canGoBack={false} className="mb-2" />
      <List
        data={content}
        contentContainerStyle={sharedStyles.contentContainer}
        numColumns={numCols}
        key={`dashboard-grid-${numCols}`}
        renderItem={({ item }) => {
          return (
            <Link href={item.href} asChild>
              <Pressable
                className={`${item.bgClassName} py-8 px-4 rounded mx-1 mb-2 shadow-md items-center justify-center active:opacity-90 hover:shadow-xl hover:scale-105 transition-all min-h-[140]`}
              >
                <View className="h-9">
                  <MIcon name={item.icon} size={36} color="white" />
                </View>
                <Text className="text-white font-bold text-center mt-3 text-base leading-tight" numberOfLines={2}>
                  {item.title}
                </Text>
              </Pressable>
            </Link>
          )
        }}
        ListFooterComponent={<SafeAreaView edges={["bottom"]} />}
      />
    </>
  )
}
